module.exports = __webpack_public_path__ + "static/media/S (139).335e381d.jpg";